import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import ua from "./locales/ua.json";

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources: {
			ua: { translation: ua },
			en: { translation: en },
		},

		fallbackLng: "en",

		supportedLngs: ["en", "ua"],

		detection: {
			order: ["localStorage", "navigator"],
			caches: ["localStorage"],
		},

		interpolation: {
			escapeValue: false,
		},
	});

const browserLang = navigator.language.toLowerCase();

if (browserLang.includes("uk")) {
	i18n.changeLanguage("ua");
} else {
	i18n.changeLanguage("en");
}

document.documentElement.lang = i18n.language;
i18n.on("languageChanged", (lng) => {
	document.documentElement.lang = lng;
});

export default i18n;
